import React, { useRef, useState } from "react";
import "./Contact.css";
import emailjs from "emailjs-com";

const Contact = () => {
  const form = useRef(null);
  const [isSending, setIsSending] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState(false);

  const sendEmail = async (event) => {
    event.preventDefault();
    setIsSending(true);
    setSubmitSuccess(false);
    setSubmitError(false);

    try {
      await emailjs.sendForm(
        "service_nyqcopq",
        "template_xnduhgd",
        form.current,
        "SSWUFv2_J6iy1ME7w"
      );
      form.current?.reset();
      setSubmitSuccess(true);
    } catch (error) {
      console.error("No se pudo enviar el formulario de contacto", error);
      setSubmitError(true);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section className="container-c" aria-labelledby="contact-title">
      <div className="container p-2 my-auto">
        <div className="row justify-content-center position-c">
          <div className="col-lg-8 d-flex justify-content-center">
            <div className="card border-0 rounded-3 shadow-lg">
              <div className="card-body p-4 form-c">
                <div className="text-center">
                  <h2 id="contact-title" className="fs-2 fw-light text-light">Contacto</h2>
                  <p className="mb-4 text-light fs-6">Contanos tu necesidad. Te responderemos para analizar el servicio y preparar una propuesta personalizada.</p>
                </div>
                <form id="contactForm" ref={form} onSubmit={sendEmail}>
                  <div className="form-floating mb-3">
                    <input className="form-control" id="name" name="user_name" type="text" placeholder="Nombre" autoComplete="name" required />
                    <label htmlFor="name">Nombre</label>
                  </div>
                  <div className="form-floating mb-3">
                    <input className="form-control" id="emailAddress" name="user_email" type="email" placeholder="Correo electrónico" autoComplete="email" required />
                    <label htmlFor="emailAddress">Correo electrónico</label>
                  </div>
                  <div className="form-floating mb-3">
                    <textarea className="form-control" id="message" name="message" placeholder="Mensaje" style={{ height: "10rem" }} required />
                    <label htmlFor="message">Mensaje</label>
                  </div>
                  {isSending && <div className="text-center mb-3 text-warning fw-bolder" role="status">Enviando...</div>}
                  {submitSuccess && <div className="text-center mb-3 text-white fw-bolder" role="alert">El mensaje se envió correctamente.</div>}
                  {submitError && <div className="text-center text-danger mb-3" role="alert">No pudimos enviar el mensaje. Escribinos a valvarez@vpex.com.uy.</div>}
                  <div className="d-grid">
                    <button className="btn btn-c btn-lg text-light" id="submitButton" type="submit" disabled={isSending}>
                      {isSending ? "Enviando..." : "Enviar"}
                    </button>
                  </div>
                  <p className="text-light small mt-3 mb-0">Al enviar el formulario aceptás nuestra política de privacidad.</p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
